import React from 'react';

export default function NoPage() {
    return (
        <>
            {/* <Header /> */}
            <h2>Error 404: Not found</h2>
        </>
    )
}
